import { AdminApiService } from '../services/general';

export type StatsResultType = {
  tasks: {
    total: number;
    pending: number;
    completed: number;
  };
  contacts: number;
  webhook_events: number;
  prompts: number;
};

export const getStats = (): Promise<StatsResultType> => {
  return AdminApiService.getStatsApiAdminStatsGet();
};

export const sendChatToServer = (contact_id: string, chat: string) => {
  return AdminApiService.submitHumanInputApiAdminHumanInputPost({
    contact_id,
    message: chat,
  });
};
